import React from "react";
import "./TeamMember.css";

const initials = (name) =>
  name
    .split(" ")
    .map((part) => part[0])
    .join("");

const TeamMember = ({ name, role, image, link }) => {
  const content = (
    <>
      {image ? (
        <img
          src={image}
          alt={name}
          className="profile-photo"
          width="130"
          height="130"
          loading="lazy"
        />
      ) : (
        // No headshot yet: show their initials in the same gold circle
        <div className="profile-photo profile-initials" aria-hidden="true">
          {initials(name)}
        </div>
      )}
      <h3 className="member-name">{name}</h3>
      <p className="member-role">{role}</p>
    </>
  );

  if (link) {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="team-member team-member-link"
      >
        {content}
      </a>
    );
  }

  return <div className="team-member">{content}</div>;
};

export default TeamMember;
